export const APIOfferPlacingType = {
    UPDATE: "UPDATE",
    CORRECTION: "CORRECTION"
}